import { measureAttributeDefinitions } from "@treegram/viewer-core";
import MeasureShapesType from "@/models/enums/measure-shapes";

const magicDataUnity = (world: string): string => {
    if (measureAttributeDefinitions[world]) return measureAttributeDefinitions[world].unit;
    if (world === "number") return "u";
    if (world === "height") return "m";
    if (world === "length") return "m";
    if (world === "width") return "m";
    if (world === "thickness") return "m";
    if (world === "perimeter") return "m";
    if (world === "area") return "m²";
    if (world === "number_segments") return "u";
    if (world === "offset") return "m";
    if (world === "radius") return "m";
    return world;
};

const magicDefaultDataType = (shape: MeasureShapesType | undefined): string => {
    if (shape === "Point") return "number";
    if (shape === "Line") return "length";
    if (shape === "Polyline") return "length";
    if (shape === "Surface") return "area";
    return "number";
};

export { magicDataUnity, magicDefaultDataType };
